export const FETCH_CREATE_TEMPLATE_FOLDER_REQUEST = 'FETCH_CREATE_TEMPLATE_FOLDER_REQUEST'
export const FETCH_CREATE_TEMPLATE_FOLDER_SUCCESS = 'FETCH_CREATE_TEMPLATE_FOLDER_SUCCESS'
export const FETCH_CREATE_TEMPLATE_FOLDER_FALUIRE = 'FETCH_CREATE_TEMPLATE_FOLDER_FALUIRE'
